import axios from "axios";
// import { setAlert } from './alert';

import {
  GET_PROFILE,
  GET_PROFILES,
  PROFILE_ERROR,
  UPDATE_PROFILE,
  CLEAR_PROFILE,
  ACCOUNT_DELETED,
  SET_PROFILE_STATUS,
  JOIN_PROFILE_COMMUNITY,
  UNJOIN_PROFILE_COMMUNITY,
} from "./types";

// Get current users profile
export const getCurrentProfile = () => async (dispatch) => {
  dispatch({ type: CLEAR_PROFILE });
  try {
    const res = await axios.post("/api/profile/profile");

    dispatch({
      type: GET_PROFILE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get profile by ID
export const getProfileById = (channelid) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/profile/${channelid}`);

    dispatch({
      type: GET_PROFILE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Join Community
export const joinProfileCommunity = (id) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/profile/join`, formData, config);

    dispatch({
      type: JOIN_PROFILE_COMMUNITY,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Unjoin Community Profile
export const leaveProfileCommunity = (id) => async (dispatch) => {
  const formData = new FormData();
  formData.append("id", JSON.stringify(id));

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.post(`/api/profile/unjoin`, formData, config);

    dispatch({
      type: UNJOIN_PROFILE_COMMUNITY,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Set Profile Status
export const setProfileStatus = (formData) => async (dispatch) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axios.put(`/api/profile/profilestatus`, formData, config);

    dispatch({
      type: SET_PROFILE_STATUS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// // Create or update profile
export const updateProfile =
  (
    User,
    savedData,
    summary,
    experienceArray,
    educationArray,
    skillsArray,
    socialLinks,
    imageDataFile
  ) =>
  async (dispatch) => {
    const formData = new FormData();
    formData.append("User", JSON.stringify(User));
    formData.append("savedData", JSON.stringify(savedData));
    formData.append("summary", JSON.stringify(summary));
    formData.append("experienceArray", JSON.stringify(experienceArray));
    formData.append("educationArray", JSON.stringify(educationArray));
    formData.append("skillsArray", JSON.stringify(skillsArray));
    formData.append("socialLinks", JSON.stringify(socialLinks));

    if (imageDataFile && imageDataFile.one !== "") {
      formData.append("banner", imageDataFile.one);
    }

    if (imageDataFile && imageDataFile.two !== "") {
      formData.append("avatar", imageDataFile.two);
    }

    const config = {
      data: formData,
      header: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    try {
      const res = await axios.post(`/edit_profile`, formData, config);

      dispatch({
        type: UPDATE_PROFILE,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: PROFILE_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// // Delete experience
// export const deleteExperience = id => async dispatch => {
//   try {
//     const res = await axios.delete(`/api/profile/experience/${id}`);

//     dispatch({
//       type: UPDATE_PROFILE,
//       payload: res.data
//     });

//     dispatch(setAlert('Experience Removed', 'success'));
//   } catch (err) {
//     dispatch({
//       type: PROFILE_ERROR,
//       payload: { msg: err.response.statusText, status: err.response.status }
//     });
//   }
// };

// // Delete education
// export const deleteEducation = id => async dispatch => {
//   try {
//     const res = await axios.delete(`/api/profile/education/${id}`);

//     dispatch({
//       type: UPDATE_PROFILE,
//       payload: res.data
//     });

//     dispatch(setAlert('Education Removed', 'success'));
//   } catch (err) {
//     dispatch({
//       type: PROFILE_ERROR,
//       payload: { msg: err.response.statusText, status: err.response.status }
//     });
//   }
// };

// // Delete account & profile
// export const deleteAccount = () => async dispatch => {
//   if (window.confirm('Are you sure? This can NOT be undone!')) {
//     try {
//       await axios.delete('/api/profile');

//       dispatch({ type: CLEAR_PROFILE });
//       dispatch({ type: ACCOUNT_DELETED });

//       dispatch(setAlert('Your account has been permanantly deleted'));
//     } catch (err) {
//       dispatch({
//         type: PROFILE_ERROR,
//         payload: { msg: err.response.statusText, status: err.response.status }
//       });
//     }
//   }
// };
